import { render, staticRenderFns } from "./ContractorStaffNotesCard.vue?vue&type=template&id=dda0707a"
import script from "./ContractorStaffNotesCard.vue?vue&type=script&lang=ts"
export * from "./ContractorStaffNotesCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dda0707a')) {
      api.createRecord('dda0707a', component.options)
    } else {
      api.reload('dda0707a', component.options)
    }
    module.hot.accept("./ContractorStaffNotesCard.vue?vue&type=template&id=dda0707a", function () {
      api.rerender('dda0707a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/projects/activities/ContractorStaffNotesCard.vue"
export default component.exports